<template>
  <div>
    <section-header heading="2" ja="GIMMI（ギミ）とは？"/>
    <div class="textArea">
      <p>
        「GIMMI（ギミ）」は、撮影・らくがき・シール印刷を１つのブースに詰め込んだ新しいプリクラ機です。<br>
        セルフシャッター「プリリモコン」を使った撮影や、
        自分の好みの盛りを作れる「専用盛りメイカー」、通常の撮影に加えて、らくがき中に切り替えられる「追加撮影機能」等、様々な新機能を楽しむことができます。<br>
        詳細は公式サイトをご確認ください。
      </p>
      <p>
        <a class="textLink" href="unity:command?openurl=https://puri.sega.jp/gimmi/">GIMMI 公式サイト</a>
      </p>
    </div>

    <section-header heading="2" ja="GIMMIを遊べるお店は？"/>
    <div class="textArea">
      <p>
        遊べるお店は
        <a class="textLink" href="unity:command?openurl=https://puri.sega.jp/location-map/?id=gimmi">店舗検索</a>
        からご確認ください。
      </p>
    </div>
    <sub-btn @click="onBack()">戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "AppaboutGimmi01",
  components: {
    SectionHeader,
    SubBtn
  },
  methods: {
    onBack() {
        this.$router.push("/AppaboutGimmi")
    }
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
}
.textLink { color: #DA2240; }
</style>
